import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { inspreekenHref } from "../inspreken/relation";
import { useInsprekenStatus } from "../inspreken/useInsprekenStatus";
import type { CallRelation } from "./callPrompt";
import { useCallPrompt } from "./useCallPrompt";

/**
 * "Gesprek met <naam> gehad?" at the top of a relation page after tapping its phone number.
 * Every choice clears the remembered call. After a call or meeting was saved on the page, the
 * page calls `clearCall()` and remounts the banner (new `key`), which then finds nothing.
 */
export function CallPromptBanner({
  relation,
  onLogCall,
}: {
  relation: CallRelation;
  onLogCall: () => void;
}) {
  const { visible, dismiss } = useCallPrompt(relation);
  const { available } = useInsprekenStatus();
  const navigate = useNavigate();
  if (!visible) return null;
  return (
    <div
      role="status"
      className="flex flex-col gap-2 rounded-lg border border-border bg-muted p-3 text-sm sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="font-medium">Gesprek met {relation.name} gehad?</p>
      <div className="flex flex-wrap gap-2">
        {available ? (
          <Button
            variant="outline"
            className="min-h-11 sm:min-h-0"
            onClick={() => {
              dismiss();
              navigate(
                inspreekenHref({ type: relation.type, id: relation.id }),
              );
            }}
          >
            Inspreken
          </Button>
        ) : null}
        <Button
          className="min-h-11 sm:min-h-0"
          onClick={() => {
            dismiss();
            onLogCall();
          }}
        >
          Gesprek vastleggen
        </Button>
        <Button
          variant="ghost"
          className="min-h-11 sm:min-h-0"
          onClick={dismiss}
        >
          Niet nu
        </Button>
      </div>
    </div>
  );
}
